<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-module-submodule-select
              :pageId="this.$options.name"
              :selectedMd="searchBox.moduleCode"
              :selectedSmd="searchBox.subModuleCode"
              :defaultMdOption="'all'"
              :defaultSmdOption="'all'"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_IF_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model.trim="searchBox.interfaceId.key"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_BF_BCJB_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model.trim="searchBox.beforeBatchJobId.key"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_AF_BCJB_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model.trim="searchBox.afterBatchJobId.key"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-7">
            <sui-code-select
              :selected="searchBox.searchCondition"
              codeId="COD_BCJB_SEARCH_COND"
              :defaultOption="'all'"
              style="width:58.5%"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model.trim="searchBox.searchWord.key"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onResetSearch"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_Scr"
            @click="onSearchClick"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>

          <!--<sui-button type="button" class="comm_btn_scr" @click="onTestClick">Test</sui-button>-->
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grid1"
        :dataset="'dsBatchJob'"
        :columns="gridColumns0"
        :showDisplayCountControl="false"
        :initial-pagesize="10"
        :multiselect="true"
      />

      <div class="comm_btn_wrap">
        <!-- <sui-button
          type="button"
          class="comm_btn_border"
          @click="onModify"
        >
          {{ $t("MSG_BTN_MOD") }}
        </sui-button>
        -->
        <sui-button
          v-permission:delete="this.$options.name"
          type="button"
          class="comm_btn_border"
          @click="onDelete"
        >
          {{ $t("MSG_BTN_DEL") }}
        </sui-button>
        <sui-button
          v-permission:create="this.$options.name"
          type="button"
          class="comm_btn_solid"
          @click="onCreate"
        >
          {{ $t("MSG_BTN_RGST") }}
        </sui-button>
      </div>
    </sui-page-contents>

    <!-- compoenets -->
    <sui-popup
      v-model="isShowPopUpNew"
      :title="$t('MSG_TXT_BCJB_RGST')"
    >
      <p01
        :pageId="this.$options.name"
        @save="save('NEW')"
        @close="popOpenOrClose('NEW')"
      />
    </sui-popup>
    <sui-popup
      v-model="isShowPopUpModify"
      :title="$t('MSG_TIT_BCJB_DTL')"
    >
      <p02
        :pageId="this.$options.name"
        :batchJobId="batchJobId"
        @save="save('MODIFY')"
        @close="popOpenOrClose('MODIFY')"
      />
    </sui-popup>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

import p01 from './components/PGE_CMS_00004_P01';
import p02 from './components/PGE_CMS_00004_P02';

export default {
  name: 'PGE_CMS_00004', // eslint-disable-line vue/name-property-casing
  components: {
    p01,
    p02,
  },
  extends: BasePage,
  data() {
    return {
      // Search Box
      searchBox: {
        // 선택된 select box 값
        moduleCode: { key: '', label: '' },
        subModuleCode: { key: '', label: '' },
        batchJobCycle: { key: '', label: '' },
        interfaceId: { key: '', label: '' },
        searchCondition: { key: '', label: '' },
        searchWord: { key: '', label: '' },
        beforeBatchJobId: { key: '', label: '' },
        afterBatchJobId: { key: '', label: '' },
      },

      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleName',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_BCJB_ID'),
        datafield: 'batchJobId',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButtonList(row, column, value, htmlElement, {
            handler: this.onGridButtonClicked,
          }, this.dsBatchJob, this.$refs.grid1);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_BCJB_NM'),
        datafield: 'batchJobName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButtonList(row, column, value, htmlElement, {
            handler: this.onGridButtonClicked,
          }, this.dsBatchJob, this.$refs.grid1);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_CYCL'),
        datafield: 'batchJobCycle',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_IF_ID'),
        datafield: 'interfaceId',
      }, {
        text: this.$t('MSG_TXT_BF_BCJB_ID'),
        datafield: 'beforeBatchJobId',
      }, {
        text: this.$t('MSG_TXT_AF_BCJB_ID'),
        datafield: 'afterBatchJobId',
      }],

      // 팝업 관련
      isShowPopUpNew: false,
      isShowPopUpModify: false,
      batchJobId: null,
    };
  },
  datasets: [{
    id: 'dsBatchJob',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'deleteYn', map: 'deleteYn' },
      { type: 'string', name: 'moduleCode', map: 'moduleCode' },
      { type: 'string', name: 'moduleName', map: 'moduleName' },
      { type: 'string', name: 'subModuleCode', map: 'subModuleCode' },
      { type: 'string', name: 'subModuleName', map: 'subModuleName' },
      { type: 'string', name: 'batchJobId', map: 'batchJobId' },
      { type: 'string', name: 'batchJobName', map: 'batchJobName' },
      { type: 'string', name: 'batchJobCycle', map: 'batchJobCycle' },
      { type: 'string', name: 'interfaceId', map: 'interfaceId' },
      { type: 'string', name: 'beforeBatchJobId', map: 'beforeBatchJobId' },
      { type: 'string', name: 'afterBatchJobId', map: 'afterBatchJobId' },
      { type: 'string', name: 'batchJobProgramId', map: 'batchJobProgramId' },
      { type: 'string', name: 'batchJobContent', map: 'batchJobContent' },
      { type: 'string', name: 'searchCondition', map: 'searchCondition' },
      { type: 'string', name: 'searchWord', map: 'searchWord' },
    ],
  }],
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  mounted() {
    this.resetSearchBox();
  },
  beforeUpdate() {
    // data 변경전 DOM 정보가 필요한 경우
  },
  updated() {
    // data 변경후 DOM 정보가 필요한 경우
  },
  beforeDestroy() {
    // 이벤트 핸들러 및 사용한 서드 파티 라이브러리 자원 반환
  },
  destroyed() {
    // 남아 있는 자원 반환
  },
  methods: {
    // 내부 함수 기술
    // 이벤트 핸들러 기술, prefix on 적용
    onGridButtonClicked(btn, dataRow) {
      this.batchJobId = dataRow.batchJobId[0].key;
      this.popOpenOrClose('MODIFY');
      return true;
    },
    /** ***************************************************************************
      이벤트 영역
      ***************************************************************************** */
    onResetSearch() {
      this.resetSearchBox();
    },
    onSearchClick() {
      this.searchBatchJob();
    },
    onCreate() {
      this.batchJobId = '';
      this.popOpenOrClose('NEW');
    },
    // onModify() {
    //   const selectedRawsData = this.dsBatchJob.getSelectedRawData();
    //
    //   if (selectedRawsData.length !== 1) {
    // eslint-disable-next-line max-len
    //     utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_CONFIRM'), this.$t('MSG_TXT_BCJB_ID')), null, this.deleteBatchJob);
    //     return false;
    //   }
    //
    //   this.batchJobId = selectedRawsData[0].batchJobId[0].key;
    //   this.popOpenOrClose('MODIFY');
    //   return true;
    // },
    onDelete() {
      utils.messageBox('confirm', this.$t('MSG_ALT_IS_DEL_DATA'), null, this.deleteBatchJob);
    },
    /** ***************************************************************************
      함수 영역
      ***************************************************************************** */
    resetSearchBox() {
      utils.forEach(this.searchBox, (values, key) => {
        this.searchBox[key] = { key: '', label: '' };
      });

      this.searchBox.moduleCode.key = 'ALL';
      this.searchBox.subModuleCode.key = 'ALL';
      this.searchBox.searchCondition.key = 'ALL';
    },
    searchBatchJob() {
      // searchBox -> paramsObj변환 { key : value, key : value }
      const queryParams = utils.reduce(this.searchBox, (result, value, key) => {
        const objResult = utils.clone(result);
        if (utils.isUndefined(value) === false && value !== null) {
          objResult[key] = utils.isUndefined(value.key) ? utils.trim(value) : utils.trim(value.key);
        }
        return objResult;
      }, {});


      http.request(this.$options.name, 'DTS_CMS_00011', {
        query: queryParams,
      }).then(res => {
        console.log(res);
        // utils.printDatasetFieldsFromObject(res.data[0]); // data 기준으로 datafiels를 출력해주는 함수

        utils.forEach(res.data, item => {
          const objItem = item;
          objItem.batchJobId = [{ key: item.batchJobId, label: item.batchJobId, type: 'sublink' }];
          objItem.batchJobName = [{ key: item.batchJobName, label: item.batchJobName, type: 'sublink' }];
        });

        this.dsBatchJob.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
        this.dsBatchJob.clearSelection();
      }).catch(error => {
        console.log(error);
      });
      return true;
    },
    popOpenOrClose(sPopUpFlag) {
      if (sPopUpFlag === 'NEW') {
        this.isShowPopUpNew = !this.isShowPopUpNew;
      } else if (sPopUpFlag === 'MODIFY') {
        this.isShowPopUpModify = !this.isShowPopUpModify;
      }
    },
    save(sSaveFlag) {
      this.popOpenOrClose(sSaveFlag);
      this.searchBatchJob();
    },
    deleteBatchJob() {
      const selectedRawsData = this.dsBatchJob.getSelectedRawData();
      if (selectedRawsData.length === 0) return;

      const dataParams = [];
      utils.forEach(selectedRawsData, item => {
        dataParams.push({
          batchJobId: item.batchJobId[0].key, // [{ key: item.batchJobId, label: item.batchJobId, type: 'sublink' }];
        });
      });

      http.request(this.$options.name, 'DTS_CMS_00019', {
        path: {},
        data: dataParams,
      }).then(res => {
        console.log(res);
        this.searchBatchJob();
        utils.messageBox('success', this.$t('MSG_ALT_DEL_DATA'));
      }).catch(error => {
        console.log(error);
      });
    },

  },
};
</script>
<style scoped>
</style>
